import {
  org_coursera_product_enterprise_contract_EnterpriseContractState as ContractStates,
  org_coursera_enterprise_contract_tag_EnterpriseContractTag as ContractTags,
  org_coursera_enterprise_contract_migration_ContractMigrationStatus as MigrationStatus,
} from 'bundles/enterprise-admin-contracts/components/__generated__/globalTypes';

export const ALLOWED_IMPORT_MIGRATION_STATUS = [MigrationStatus.FAILED, MigrationStatus.SUCCESSFUL];
export const ALLOWED_IMPORT_CONTRACT_STATES = [ContractStates.ACTIVE, ContractStates.CREATED, ContractStates.PAUSED];

export const CONTRACT_NAME_MAX_LENGTH = 50;
export const SALESFORCE_CASE_NUMBER_MAX_LENGTH = 30;

export const DEPRECATED_CONTRACT_TAGS = [ContractTags.C4C_CORONA_TRIAL, ContractTags.CAREER_ACADEMY_FULL];

export const CONTRACT_PURPOSE = {
  TRIAL: 'TRIAL',
  DEMO: 'DEMO',
};

export const CONTRACT_TAGS = {
  C4C: 'C4C',
  C4C_CORONA_TRIAL: 'C4C_CORONA_TRIAL',
  C4C_FACULTY: 'C4C_FACULTY',
  C4C_FREEMIUM: 'C4C_FREEMIUM',
  C4C_GP_GOOG: 'C4C_GP_GOOG',
  C4C_MOROCCO: 'C4C_MOROCCO',
  C4C_PARTNER_CONSORTIUM: 'C4C_PARTNER_CONSORTIUM',
  C4C_UKRAINE: 'C4C_UKRAINE',
  C4C_UPSWELL: 'C4C_UPSWELL',
  C4ER_PORTUGUESE: 'C4ER_PORTUGUESE',
  C4ER_SPANISH: 'C4ER_SPANISH',
  C4FW_ARABIC: 'C4FW_ARABIC',
  C4FW_ENGLISH: 'C4FW_ENGLISH',
  C4FW_FRENCH: 'C4FW_FRENCH',
  C4FW_GERMAN: 'C4FW_GERMAN',
  C4FW_PORTUGUESE: 'C4FW_PORTUGUESE',
  C4FW_SPANISH: 'C4FW_SPANISH',
  C4P: 'C4P',
  C4T_FREE_TRIAL: 'C4T_FREE_TRIAL',
  C4WR_CORONA_TRIAL: 'C4WR_CORONA_TRIAL',
  CAREER_ACADEMY_FULL: 'CAREER_ACADEMY_FULL',
  CAREER_ACADEMY_LIMITED: 'CAREER_ACADEMY_LIMITED',
  COURSERA_CORE: 'COURSERA_CORE',
  DATA_TECH_ACADEMY: 'DATA_TECH_ACADEMY',
  ENT_WD: 'ENT_WD',
  ENT_WD_GP: 'ENT_WD_GP',
  GCP_CLOUD_LEADERS: 'GCP_CLOUD_LEADERS',
  GCP_CLOUD_SELECT: 'GCP_CLOUD_SELECT',
  GCP_KICKSTART: 'GCP_KICKSTART',
  GCP_RESELLER: 'GCP_RESELLER',
  GEN_AI: 'GEN_AI',
  GEN_AI_PROMO: 'GEN_AI_PROMO',
  GEN_AI_THOUGHT_PARTNER_PROMO: 'GEN_AI_THOUGHT_PARTNER_PROMO',
  GOOGLE_SCHOLARSHIP: 'GOOGLE_SCHOLARSHIP',
  GROW_WITH_GOOGLE: 'GROW_WITH_GOOGLE',
  GWG_AI_ESSENTIALS: 'GWG_AI_ESSENTIALS',
  GWG_CC: 'GWG_CC',
  GWG_E2E: 'GWG_E2E',
  GWG_ENTERPRISE: 'GWG_ENTERPRISE',
  GWG_SMB: 'GWG_SMB',
  IBM_KICKSTART_COMB: 'IBM_KICKSTART_COMB',
  IBM_KICKSTART_IND: 'IBM_KICKSTART_IND',
  IBM_STANDARD: 'IBM_STANDARD',
  INDUSTRY_PROF_CERTS: 'INDUSTRY_PROF_CERTS',
  LEADERSHIP_LITE: 'LEADERSHIP_LITE',
  META_SCHOLARSHIP: 'META_SCHOLARSHIP',
  PRIVATE_CONTENT_ONLY: 'PRIVATE_CONTENT_ONLY',
  PWC_RESELLER: 'PWC_RESELLER',
  SOCIAL_IMPACT: 'SOCIAL_IMPACT',
  CAREER_ACADEMY_PLUS: 'CAREER_ACADEMY_PLUS',
  COURSERA_PLATFORM_ONLY: 'COURSERA_PLATFORM_ONLY',
  USA_2025_DEIA_EO: 'USA_2025_DEIA_EO',
  DATA_ACADEMY: 'DATA_ACADEMY',
  PRODUCT_ACADEMY: 'PRODUCT_ACADEMY',
  IT_ACADEMY: 'IT_ACADEMY',
  IT_SKILLS_TRACK: 'IT_SKILLS_TRACK',
  DATA_SKILLS_TRACK: 'DATA_SKILLS_TRACK',
  SOFTWARE_PRODUCT_SKILLS_TRACK: 'SOFTWARE_PRODUCT_SKILLS_TRACK',
  GENAI_SKILLS_TRACK: 'GENAI_SKILLS_TRACK',
} as const;

export const SKILL_TRACK_CONTRACT_TAGS = [
  CONTRACT_TAGS.IT_SKILLS_TRACK,
  CONTRACT_TAGS.DATA_SKILLS_TRACK,
  CONTRACT_TAGS.SOFTWARE_PRODUCT_SKILLS_TRACK,
  CONTRACT_TAGS.GENAI_SKILLS_TRACK,
];
